import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';
import { ProductPlanService } from 'services/productplan.service';

@CredentialRequired(CredentialType.EditProductPlanTerminationNoticePeriod)
@Component({
	selector: 'edit-product-plan-termination-notice-period',
	templateUrl: './edit-product-plan-termination-notice-period.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, CustomSelectComponent, TranslatePipe]
})
export class EditProductPlanTerminationNoticePeriodComponent {

	inputType = InputType;

	private _productPlan!: ProductPlanModel;
	updatedPeriod = 0;
	terminationNoticePeriods = [0, 3].map(period => new SelectListItemModel(period, this.translate.transform('company.product-plan.termination-notice-period-option.' + period)));
	
	@Input()
	set productPlan(plan: ProductPlanModel) {
		this._productPlan = plan;
		this.updatedPeriod = plan.terminationNoticePeriod;
	}
	get productPlan() {
		return this._productPlan;
	}

	constructor(private readonly productPlanService: ProductPlanService, private readonly navigation: NavigationService, private readonly translate: TranslatePipe) { }

	saveProductPlan() {
		this.productPlanService.updateProductPlanTerminationNoticePeriod(this.productPlan.id!, this.updatedPeriod).then(_ => { this.navigation.closeView(this); });
	}
}
